import { useContext, useEffect } from 'react';
import { Response } from 'node-fetch';
import { PNGlobalContext } from './PNGlobalContext';
import { SET_PATIENT_ON_AD_HOC_IDG_AGENDA } from './constants';
export const AdHocIDGAgendaLoader = ({
  pim,
  patientNumber
}) => {
  const {
    dispatchPN
  } = useContext(PNGlobalContext);
  useEffect(() => {
    if (!dispatchPN || !pim || !patientNumber) {
      return;
    }

    dispatchPN({
      type: SET_PATIENT_ON_AD_HOC_IDG_AGENDA,
      payload: null
    });
    pim.isPatientOnAdHocIDGAgenda(patientNumber).then(result => {
      if (result instanceof Response) {
        dispatchPN({
          type: SET_PATIENT_ON_AD_HOC_IDG_AGENDA,
          payload: false
        });
        return;
      }

      dispatchPN({
        type: SET_PATIENT_ON_AD_HOC_IDG_AGENDA,
        payload: !!result
      });
    });
  }, [dispatchPN, pim, patientNumber]);
  return null;
};